var _path, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 40c11.046 0 20-8.9543 20-20 0-11.046-8.9543-20-20-20-11.046 0-20 8.9543-20 20 0 11.046 8.9543 20 20 20z",
    fill: "#0CA5EB"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.52501 -.52501 .52501 .52501 -1.0004 20)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.6937
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90,30.843,31.516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.981 16.43 4.2426 4.2426-4.2426 4.2426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.095 20.673h8.1646"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180,31.18,20.336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.981 16.43 4.2426 4.2426-4.2426 4.2426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.095 20.673h8.1646"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90,31.516,9.1567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.981 16.43 4.2426 4.2426-4.2426 4.2426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.095 20.673h8.1646"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.359 -.67289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.981 16.43 4.2426 4.2426-4.2426 4.2426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.095 20.673h8.1646"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19.984,
    r: 2.8817,
    strokeDashoffset: 11.411,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      paintOrder: "stroke markers fill"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFly);
export default __webpack_public_path__ + "static/media/icon_fly.645d495ab96a262c50dc028b03c608ff.svg";
export { ForwardRef as ReactComponent };